import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { FaPaperPlane } from "react-icons/fa";
import { API_BASE_URL } from "../../api/config";
import { useTranslateKey } from "../translation/useTranslateKey";
import { getCookie } from "../../api/csrf";

const Newsletter = () => {
  const t = useTranslateKey();

  // Schema validation with yup
  const schema = Yup.object().shape({
    email: Yup.string()
      .required(t("error.requiredEmail"))
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,

        t("error.invalidEmail")
      ),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    console.log(data.email);
    try {
      const response = await fetch(`${API_BASE_URL}/newsletter-subscribe/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": getCookie("csrftoken"),
        },
        credentials: "include",
        body: JSON.stringify(data),
      });

      const result = await response.json();
      console.log(result);
      reset();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div>
      <h4 className="text-white text-lg font-semibold mb-6">
        {t("newsletter")}
      </h4>
      <p className="text-gray-300 mb-4">{t("newsLetterDescription")}.</p>
      <form onSubmit={handleSubmit(onSubmit)} noValidate className="space-y-3">
        <input
          type="email"
          placeholder={t("yourEmail")}
          {...register("email")}
          className="search-input w-full text-sm py-1.5 px-3 bg-transparent border border-[#332D7E] rounded-lg focus:border-[#F9C835] text-white"
          autoComplete="off"
        />
        {errors.email && (
          <p className="text-red-400 text-sm mt-2">{errors.email.message}</p>
        )}
        <button
          type="submit"
          className="search-btn w-full py-2 px-4 rounded-lg text-sm font-semibold flex items-center justify-center gap-2 hover:shadow-lg hover:shadow-[#F9C835]/20 transition-all duration-300"
        >
          <FaPaperPlane />
          <span>{t("subscribe")}</span>
        </button>
      </form>
    </div>
  );
};

export default Newsletter;
